import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/TxtUploader.css";
import API_BASE_URL from "../config";

const TxtUploader = () => {
  const [file, setFile] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/auth/me`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error("Not logged in");
        }
      })
      .then((data) => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          const userObj = JSON.parse(storedUser);
          setUsername(userObj.username);
        }
      })
      .catch(() => {
        localStorage.removeItem("user");
        navigate("/login");
      });
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setLoading(false);
  };

  const handleClear = () => {
    setFile(null);
    document.getElementById("fileInput").value = null;
  };

  const handleUpload = () => {
    if (!file) {
      setMessages((prev) => [...prev, "Please select a .txt file."]);
      return;
    }

    setLoading(true);
    setMessages((prev) => [...prev, `Uploading "${file.name}"...`]);

    const formData = new FormData();
    formData.append("file", file);

    fetch(`${API_BASE_URL}/api/admin/upload`, {
      method: "POST",
      body: formData,
      credentials: "include",
    })
      .then(async (res) => {
        setLoading(false);
        const response = await res.json();

        const newMessages = [];
        newMessages.push(response.message || "Upload result:");

        if (response.errors && response.errors.length > 0) {
          response.errors.forEach((err) => {
            newMessages.push(`Row ${err.row}: ${err.error}`);
          });
        }

        setMessages((prev) => [...prev, ...newMessages]);
        handleClear();
      })
      .catch((err) => {
        setLoading(false);
        setMessages((prev) => [
          ...prev,
          `Upload error: ${err.message || "Unknown error"}`,
        ]);
      });
  };

  const handleLogout = () => {
    fetch(`${API_BASE_URL}/api/auth/logout`, {
      method: "POST",
      credentials: "include",
    }).finally(() => {
      localStorage.removeItem("user");
      navigate("/login");
    });
  };

  return (
    <div>
      <div className="top-bar">
        <span className="welcome-msg">Welcome, {username}</span>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
      <div className="uploader-container">
        <h2>Upload TXT File to MYSQL database</h2>
        <input
          id="fileInput"
          type="file"
          accept=".txt"
          onChange={handleFileChange}
          disabled={loading}
        />
        {file && <p className="file-name">Selected: {file.name}</p>}

        <div className="button-group">
          <button onClick={handleUpload} disabled={!file || loading}>
            {loading ? "Uploading..." : "Upload"}
          </button>
          <button onClick={handleClear} disabled={loading || !file}>
            Clear
          </button>
        </div>

        {loading && (
          <div className="loading-msg">Uploading file, please wait...</div>
        )}

        <div className="message-box">
          {messages.map((msg, idx) => (
            <p key={idx}>{msg}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TxtUploader;
